import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { useTradeFormStore } from '../components/TradePage/TradeForm/TradeFormState';
import { ASSET_ROUTE_URL } from '../constants/routes';
import { localStorageKeys } from '../lib/localstorageKeys';

export const useOrderbookRowClick = () => {
  const setAmount = useTradeFormStore((x) => x.setAmount);
  const setOrderType = useTradeFormStore((x) => x.setOrderType);
  const setLimitPrice = useTradeFormStore((x) => x.setLimitPrice);

  const [orderbookSetSizeOnClick] = useLocalStorage(
    localStorageKeys.orderbookSetSizeOnClick,
    false
  );

  const navigate = useNavigate({ from: ASSET_ROUTE_URL });

  const handleRowClick = useCallback(
    (price: bigint, amount: bigint) => {
      if (orderbookSetSizeOnClick) {
        setAmount(amount);
      }
      setLimitPrice(price);
      setOrderType('LIMIT', () => {
        void navigate({ search: (prev) => ({ ...prev, orderType: 'limit' }) });
      });
    },
    [orderbookSetSizeOnClick, setAmount, setLimitPrice, setOrderType, navigate]
  );

  return handleRowClick;
};
